var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ControlBar", {
        attrs: {
          projectName: _vm.projectName,
          onAdvancedSearch: true,
          selectedFolderId: _vm.selectedFolderId
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "advancedSearchHome" }, [
        _c("div", { staticClass: "inputSection conditions" }, [
          _c("label", { staticClass: "inputLabel" }, [
            _vm._v("Advanced Search Conditions")
          ]),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "loadingOverlay" }, [
                _c(
                  "div",
                  { staticClass: "loading" },
                  [_c("ScaleLoader"), _vm._v(" Loading…")],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "matchAllWrapper" }, [
            _c("label", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.internal_matchAll,
                    expression: "internal_matchAll"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.internal_matchAll)
                    ? _vm._i(_vm.internal_matchAll, null) > -1
                    : _vm.internal_matchAll
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.internal_matchAll,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.internal_matchAll = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.internal_matchAll = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.internal_matchAll = $$c
                    }
                  }
                }
              }),
              _vm._v(" All conditions must match")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "conditionList" },
            _vm._l(_vm.internal_conditions, function(condition) {
              return _c("FilterCondition", {
                key: condition.FilterConditionId,
                staticClass: "condition",
                attrs: { condition: condition },
                on: { delete: _vm.deleteCondition }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              attrs: { type: "button", value: "New Condition" },
              on: { click: _vm.newCondition }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "buttonBar" }, [
          _c("input", {
            attrs: { type: "button", value: "Copy conditions from a Filter" },
            on: { click: _vm.copyConditionsFromFilter }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              type: "button",
              value: "Create new Filter from these conditions"
            },
            on: { click: _vm.newFilter }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttonBar" },
          [
            _c(
              "router-link",
              {
                staticClass: "execSearchButton",
                attrs: { to: _vm.searchRoute }
              },
              [
                _c("vsvg", {
                  staticClass: "searchIcon",
                  attrs: { sprite: "search", role: "presentation" }
                }),
                _vm._v("\n\t\t\t\tExecute Search\n\t\t\t")
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notes" }, [
      _c("div", { staticClass: "notesHeading" }, [
        _vm._v("Advanced Search Notes")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notesBody" }, [
        _c("ul", [
          _c("li", [
            _vm._v("In "),
            _c("b", [_vm._v("conditions")]),
            _vm._v(", the "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" and "),
            _c("code", { staticClass: "inline" }, [_vm._v("Query")]),
            _vm._v(" fields are case-insensitive.")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("A "),
            _c("b", [_vm._v("condition's")]),
            _vm._v(" "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" field can be "),
            _c("code", { staticClass: "inline" }, [_vm._v("EventType")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("SubType")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Message")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Date")]),
            _vm._v(", "),
            _c("code", { staticClass: "inline" }, [_vm._v("Color")]),
            _vm._v(", or any application-specific tag key. An empty "),
            _c("code", { staticClass: "inline" }, [_vm._v("Field Name")]),
            _vm._v(" will fail the condition. "),
            _c("code", { staticClass: "inline" }, [_vm._v("Folder")]),
            _vm._v(
              " is not available to be searched at this time because folders are a tree structure and the string path for each event is not stored in the database, nor is it easy to generate the string using SQL."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }